<template>
  <div>
    <img src="../../../assets/door/tphtitle.jpg" alt="" style="width: 100%;">
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>